import {defineSlotRecipe} from '@chakra-ui/react3'

export const LAYOUT_FIELD_PROPS_MAP = {
    default: {hideLabel: false},
    condensed: {hideLabel: true}
}

export const newsletterFormSlotRecipe = defineSlotRecipe({
    className: 'newsletter-form',
    slots: ['form', 'fields', 'emailGroup', 'consent', 'submit'],

    base: {
        form: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-16'
        },
        fields: {
            display: 'flex',
            flexDirection: 'column'
        },
        emailGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-4'
        },
        consent: {
            paddingTop: 'spacing-6'
        },
        submit: {
            alignSelf: 'flex-start'
        }
    },

    variants: {
        layout: {
            default: {
                fields: {gap: 'spacing-24'}
            },
            condensed: {
                fields: {gap: 'spacing-8'}
            }
        }
    },

    defaultVariants: {
        layout: 'default'
    }
})
